<template>
  <div class="text-xs-center pt-3">
    <span class="order-text-pagename elevation-2">Cancel</span>
    <transition name="slide-x-reverse-transition" mode="out-in">
      <orderListTable
        :filterDate="true"
        :fetching_order="isLoading"
        :dateTimeDineIn="dateTimeDineIn"
        :orderList="orderList"
        @onSelectDateTimeDineIn="
          dateTimeDineIn = $event;
          fetchData();
        "
      ></orderListTable>
    </transition>
  </div>
</template>

<script>
import orderListTable from "@/components/back-office/DineIn/Order/OrderTable.vue";
import { mapActions } from "vuex";

export default {
  computed: {},
  components: {
    orderListTable,
  },
  data() {
    return {
      interval_order_cancel: null,
      dateTimeDineIn: new Date().toISOString().substr(0, 10),
      orderList: [],
      isLoading: false,
    };
  },
  methods: {
    ...mapActions({ fetchOrderList: "fetchDineIn/fetchOrderList" }),
    async getData() {
      await this.fetchData();
      let vm = this;
      this.interval_order_cancel = setInterval(async function() {
        vm.fetchData();
      }, 60000);
    },
    async fetchData() {
      this.isLoading = true;
      let result = await this.fetchOrderList({
        order_status: [4],
        datetime_dine_in: this.dateTimeDineIn,
      });
      this.isLoading = false;
      if (result == false) return;
      this.orderList = result;
      return;
    },
  },
  beforeDestroy() {
    clearInterval(this.interval_order_cancel);
  },
  mounted() {
    this.getData();
    const path = [
      {
        text: "Cancel list",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped></style>
